// Backing functions for the `POLICY_CARD` chat card
// (shared/components/_simone/ChatCard.js `type: 'policies'`) — never
// registered, so `el.call('policyStatus' | 'policyInitials' |
// 'formatPolicyMoney', …)` returned `undefined` and crashed the render
// factories that dereference `.theme`/`.label` on the result (TypeError,
// took down the whole Simone answer subtree for any card with a policy).

// Policy status → design-system theme name for the status pill + a
// human-readable label. Theme drives the pill colour per the comment above
// POLICY_CARD (success=green, warning=orange, alert=red) — same
// normalize-then-map shape as this file's sibling `stateColor`/STATE_COLOR
// (ticket state → dot colour) in ChatCard.js.
export function policyStatus(item) {
  // FA204 / frank trap — moved from module scope into this function (sole
  // consumer, pure lookup table — see longPress.js for the identical shape).
  const POLICY_STATUS = {
    active: { theme: 'success', label: 'ai.policy.status.active' },
    in_force: { theme: 'success', label: 'ai.policy.status.active' },
    current: { theme: 'success', label: 'ai.policy.status.active' },
    renewed: { theme: 'success', label: 'ai.policy.status.renewed' },
    pending: { theme: 'warning', label: 'ai.policy.status.pending' },
    pending_renewal: { theme: 'warning', label: 'ai.policy.status.pendingRenewal' },
    due: { theme: 'warning', label: 'ai.policy.status.due' },
    past_due: { theme: 'warning', label: 'ai.policy.status.pastDue' },
    expiring: { theme: 'warning', label: 'ai.policy.status.expiring' },
    expired: { theme: 'alert', label: 'ai.policy.status.expired' },
    cancelled: { theme: 'alert', label: 'ai.policy.status.cancelled' },
    canceled: { theme: 'alert', label: 'ai.policy.status.cancelled' },
    lapsed: { theme: 'alert', label: 'ai.policy.status.lapsed' },
    declined: { theme: 'alert', label: 'ai.policy.status.declined' }
  }

  const key = String(item?.status || '')
    .toLowerCase()
    .replace(/[\s-]+/g, '_')

  return (
    POLICY_STATUS[key] || {
      theme: 'tertiary',
      label: key ? key.replace(/_/g, ' ') : 'ai.policy.status.unknown'
    }
  )
}

// First + last word initials for the policy's "Initials" disc — same intent
// as `avatarType: 'initials'` on the Avatar built-in, exposed as a plain
// string helper since this disc renders a themed div, not an Avatar (see
// ChatCard.js's comment on `Initials`).
export function policyInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  if (!parts.length) {
    return '?'
  }

  const first = parts[0][0]
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''

  return (first + last).toUpperCase()
}

export function formatPolicyMoney(amount, currency) {
  const value = Number(amount)
  if (!Number.isFinite(value)) {
    return ''
  }

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2
    }).format(value)
  } catch (_) {
    // Unrecognized/malformed currency code — Intl.NumberFormat throws
    // rather than falling back.
    return `${currency ? currency + ' ' : '$'}${value.toFixed(2)}`
  }
}
